//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
export default {
  name: 'DefaultLayout',
  components: {
    FibInstallAppModal: require('@/components/FIBInstallAppModal').default
  },
  data: function data() {
    return {
      pwaTesting: process.env.PWA_TESTING
    };
  },
  computed: {
    updateComplete: get('app/GET_UPDATE_COMPLETE'),
    isApp: get('config/isApp')
  },
  mounted: function mounted() {
    if (this.updateComplete) {
      setTimeout(this.closeBanner, 5000);
    }
  },
  methods: {
    closeBanner: function closeBanner() {
      this.$store.commit('app/SET_UPDATE_COMPLETE', false);
    }
  }
};